function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import { ClassNames } from '@emotion/core';
import MediaBanner from '@domain-group/fe-co-media-banner';
import { AdSpot } from '@domain-group/fe-co-allhomes-ads';
import { usePageViewEvent, useSendEvent, EventBoundary } from '@domain-group/fe-co-allhomes-analytics';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import { BodySection, FullWidth } from '@domain-group/fe-co-allhomes-design-system';
import AllhomesLogo from '@domain-group/fe-co-allhomes-logo';
import Menu, { SeparatorMenuItem } from './components/menu/menu';
import MembershipButtons from './components/membership-buttons';
import useMenuState from './components/menu/use-menu-state';
import MembershipMenu from './components/membership-menu';
import * as styles from './desktop-header.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var DesktopHeader = _ref => {
  var navigationItems = _ref.navigationItems,
    activeItem = _ref.activeItem,
    _ref$showMediaBanner = _ref.showMediaBanner,
    showMediaBanner = _ref$showMediaBanner === void 0 ? false : _ref$showMediaBanner,
    _ref$logoType = _ref.logoType,
    logoType = _ref$logoType === void 0 ? 'color' : _ref$logoType,
    adIds = _ref.adIds;
  var _useAllhomesApi = useAllhomesApi(),
    openSignIn = _useAllhomesApi.openSignIn,
    openSignUp = _useAllhomesApi.openSignUp,
    signOut = _useAllhomesApi.signOut,
    isIdentityLoaded = _useAllhomesApi.isIdentityLoaded,
    isSignedIn = _useAllhomesApi.isSignedIn,
    user = _useAllhomesApi.user,
    getAbsoluteUrl = _useAllhomesApi.getAbsoluteUrl;
  var _useMenuState = useMenuState({
      method: 'hover'
    }),
    profileOpen = _useMenuState.menuOpen,
    profileHandlerProps = _useMenuState.menuHandlerProps,
    closeProfileMenu = _useMenuState.closeMenu;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    menuOpenEventSent = _useState2[0],
    setMenuOpenEventSent = _useState2[1];
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  usePageViewEvent({
    name: 'load-nav'
  });
  var homepageLink = getAbsoluteUrl('/');
  var handleSignIn = () => {
    openSignIn();
  };
  var handleSignUp = () => {
    openSignUp();
  };
  var handleSignout = () => {
    closeProfileMenu();
    signOut();
  };
  var handleMenuOnMouseOver = event => {
    if (isSignedIn) {
      if (!menuOpenEventSent) {
        sendEvent('load-myah');
        setMenuOpenEventSent(true);
      }
      profileHandlerProps.onMouseOver(event);
    }
  };
  return ___EmotionJSX(EventBoundary, {
    name: "header"
  }, ___EmotionJSX(FullWidth, null, showMediaBanner && ___EmotionJSX(MediaBanner, {
    links: [{
      label: 'Domain',
      url: 'https://www.domain.com.au/'
    }, {
      label: 'Commercial Real Estate',
      url: 'https://www.commercialrealestate.com.au/'
    }]
  }), ___EmotionJSX(BodySection, {
    css: styles.header
  }, ___EmotionJSX("a", {
    href: homepageLink,
    "aria-label": "Homepage"
  }, ___EmotionJSX(AllhomesLogo, {
    variant: logoType,
    css: styles.logo(logoType)
  })), ___EmotionJSX(ClassNames, null, _ref2 => {
    var css = _ref2.css;
    return ___EmotionJSX(Menu, {
      indicator: true,
      activeItem: activeItem,
      labelClass: css(styles.menuItem),
      items: [...navigationItems.flat(), SeparatorMenuItem, {
        id: 'membership',
        component: () => ___EmotionJSX("div", {
          css: styles.membershipGroup,
          onMouseOver: handleMenuOnMouseOver,
          onFocus: () => {},
          onMouseLeave: () => setMenuOpenEventSent(false)
        }, ___EmotionJSX(MembershipButtons, {
          css: styles.membershipButtons,
          onSignInClicked: handleSignIn,
          onSignUpClicked: handleSignUp,
          isSignedIn: isSignedIn,
          isIdentityLoaded: isIdentityLoaded,
          profileExpanded: profileOpen,
          user: user,
          appearance: "full"
        }), profileOpen && ___EmotionJSX(EventBoundary, {
          name: "myah"
        }, ___EmotionJSX("div", {
          css: styles.membershipMenu
        }, ___EmotionJSX(MembershipMenu, {
          user: user,
          onSignoutClick: handleSignout
        }))))
      }],
      orientation: "row"
    });
  })), ___EmotionJSX(AdSpot, {
    adbridg: adIds === null || adIds === void 0 ? void 0 : adIds.adbridg,
    gpt: {
      adId: 'adspot-728x90-pos1',
      strategy: 'window.onload'
    },
    css: styles.adSpot
  })));
};
export default DesktopHeader;